import axios from 'axios'
const CHAT_API_BASE_URL = `${process.env.REACT_APP_CHAT_API_URL}`
const recentReadRequests = new Map()
const READ_DEDUPE_MS = 2000

export const getChatsCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/user-chats-count`, data)
}

export const getUserMessagesCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/total/user/send-messages/count`, data)
}

export const createChat = (data) => {
  const user = JSON.parse(localStorage.getItem('user'))
  return axios.post(`${CHAT_API_BASE_URL}/create/chat`, data, {
    headers: {
      authorizationToken: user?.token,
    },
  })
}

export const deleteChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/delete/chat`, data)
}

export const blockChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/block/chat`, data)
}

export const unblockChat = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/unblock/chat`, data)
}

// New Functions
export const getUserChats = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/user-chats`, data)
}

export const getUserChatMessages = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/messages`, data)
}

export const getUnreadChatsCount = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/get/unread/user/messages/count`, data)
}

export const createMessage = async (data) => {
  const user = JSON.parse(localStorage.getItem('user'))
  return axios.post(`${CHAT_API_BASE_URL}/messages/create`, data, {
    headers: {
      authorizationToken: user?.token,
    },
  });
};

export const editMessage = async (data) => {
  return axios.put(`${CHAT_API_BASE_URL}/messages/edit`, data);
};

export const deleteMessage = async (data) => {
  return axios.delete(`${CHAT_API_BASE_URL}/messages/delete`, { data });
};

export const readChat = async (data) => {
  const key = `${data?.userID || ''}:${data?.chatID || ''}`
  const recent = recentReadRequests.get(key)

  if (recent && Date.now() - recent.createdAt < READ_DEDUPE_MS) {
    return recent.request
  }

  const request = axios.post(`${CHAT_API_BASE_URL}/messages/read`, data)
  recentReadRequests.set(key, { request, createdAt: Date.now() })

  setTimeout(() => {
    if (recentReadRequests.get(key)?.request === request) {
      recentReadRequests.delete(key)
    }
  }, READ_DEDUPE_MS)

  return request
};

export const uploadAttachment = (data) => {
  return axios.post(`${CHAT_API_BASE_URL}/messages/upload-urls`, data)
}
